var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"finish"},[_c('div',{staticClass:"finish-text"},[_vm._v(_vm._s(_vm.description))]),_c('pvp-btn',{attrs:{"is-loading":_vm.loadingState.finish},on:{"click":_vm.finishGame}},[_vm._v(" "+_vm._s(_vm.$t('matches.server_finish_button'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }